import { render, staticRenderFns } from "./AppointmentOnboardingView.vue?vue&type=template&id=cdee87a4&scoped=true&"
import script from "./AppointmentOnboardingView.vue?vue&type=script&lang=ts&"
export * from "./AppointmentOnboardingView.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentOnboardingView.vue?vue&type=style&index=0&id=cdee87a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdee87a4",
  null
  
)

export default component.exports